// src/components/cierreGeneral/SummaryCards.jsx
import React, { useMemo } from 'react';

// Formato colones (₡)
function formatCRC(value) {
  const n = Number(value || 0);
  return n.toLocaleString('es-CR', {
    style: 'currency',
    currency: 'CRC',
    minimumFractionDigits: 2,
  });
}

export default function SummaryCards({ data }) {
  const sales = data?.salesSummary;
  const iva = data?.ivaSummary;
  const caja = data?.cajaChica;
  const debtor = data?.biggestDebtor;

  const byMethod = useMemo(() => sales?.byMethod || [], [sales]);

  return (
    <div className="cg-grid">
      {/* Ventas Totales */}
      <div className="cg-card">
        <div className="cg-card-title">Ventas Totales</div>
        <div className="cg-card-value">{formatCRC(sales?.total || 0)}</div>
        <div className="cg-card-sub">
          Órdenes: <strong>{sales?.ordersCount || 0}</strong>
        </div>
        <div className="cg-divider" />
        <div className="cg-mini-list">
          {byMethod.length ? (
            byMethod.map((m) => (
              <div className="cg-mini-row" key={m.method}>
                <span className="cg-mini-key">{m.method}</span>
                <span className="cg-mini-val">{formatCRC(m.total)}</span>
              </div>
            ))
          ) : (
            <div className="cg-muted">Sin datos por método</div>
          )}
        </div>
      </div>

      {/* IVA */}
      <div className="cg-card">
        <div className="cg-card-title">IVA (rango)</div>
        <div className="cg-card-value">{formatCRC(iva?.ivaTotal || 0)}</div>
        <div className="cg-card-sub">
          Base: <strong>{formatCRC(iva?.baseTotal || 0)}</strong>
        </div>
        <div className="cg-divider" />
        <div className="cg-muted">
          Modo cálculo: <strong>{iva?.mode || 'INCLUDED'}</strong> · Tasa:{' '}
          <strong>{((iva?.appliesRate ?? 0.13) * 100).toFixed(0)}%</strong>
        </div>
      </div>

      {/* Mayor deudor */}
      <div className="cg-card">
        <div className="cg-card-title">Mayor deudor (CxC)</div>
        <div className="cg-card-value">{formatCRC(debtor?.debt || 0)}</div>
        <div className="cg-card-sub">
          {debtor?.clientName ? (
            <>
              Cliente: <strong>{debtor.clientName}</strong>
            </>
          ) : (
            <span className="cg-muted">Sin deudores en el rango</span>
          )}
        </div>
        <div className="cg-divider" />
        <div className="cg-muted">
          Crédito pendiente: {formatCRC(debtor?.creditOrdersPendingTotal || 0)}
        </div>
        <div className="cg-muted">
          Pagos en rango: {formatCRC(debtor?.paymentsInRange || 0)}
        </div>
      </div>

      {/* Caja chica */}
      <div className="cg-card">
        <div className="cg-card-title">Caja Chica</div>
        <div className="cg-card-value">{formatCRC(caja?.fondo || 0)}</div>
        <div className="cg-card-sub">
          Movimientos: <strong>{caja?.entriesCount || 0}</strong>
        </div>
        <div className="cg-divider" />
        <div className="cg-mini-row">
          <span className="cg-mini-key">Ingresos</span>
          <span className="cg-mini-val">{formatCRC(caja?.ingresos || 0)}</span>
        </div>
        <div className="cg-mini-row">
          <span className="cg-mini-key">Egresos</span>
          <span className="cg-mini-val">{formatCRC(caja?.egresos || 0)}</span>
        </div>
      </div>
    </div>
  );
}
